var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mailing-template-editor"},[_c('EditorVariables',{attrs:{"options":_vm.variables},on:{"select":_vm.insertVariable}}),_c('codemirror',{ref:"editor",staticClass:"mailing-template-editor__editor",attrs:{"options":_vm.options},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }